export default "__VITE_ASSET__11c85e22__"